export default __webpack_public_path__ + "static/media/justin-waldron.7135c4f3.png";